import type { Priority } from "@app/core";
import { create } from "zustand";

/** Transient (not persisted) view filter: which urgency levels are selected in
 *  the sidebar. Urgency is the horizontal third of a task's `matrix_pos`
 *  ("none" = never placed in the matrix), so like priority it is a plain
 *  membership test — empty selection means "no filter". Read by the view-filter
 *  chain via `filterByUrgencies` in lib/view-filters.ts. */
interface UrgencyFilterState {
  selected: Priority[];
  toggle: (u: Priority) => void;
  clear: () => void;
}

export const useUrgencyFilterStore = create<UrgencyFilterState>((set, get) => ({
  selected: [],
  toggle(u) {
    const selected = get().selected;
    set({ selected: selected.includes(u) ? selected.filter((s) => s !== u) : [...selected, u] });
  },
  clear() { set({ selected: [] }); },
}));
